// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {616: "30eade75608c7306",705: "e57b462ecebab3e2",80: "5a15c48db4d63486",822: "a60037849acc9384",}[chunkId] + ".js"
}